<template>
  <div id="dashboard_login">
    <div class="text_box">
      <div class="content">
        <div class="form">
          <h3 class="fashionFetish">What is the music of life ?</h3>
          <div class="webflow-style-input">
            <input class="" type="password" v-model="pass"></input>
            <button @click="login()">#_</button>
          </div>
          <div v-show="wrongMessage">
            <p style="margin: 30px;" class="fashionFetish">You are not worthy</p>
          </div>
          <div v-show="welcomeHome">
            <p style="margin: 30px;">Welcome home ... 不对！总之这里是后台，请不要再试密码啦</p>
          </div>
          <div class="loader_bar" v-show="loading">
            <img src="@/assets/img/loading_new.gif" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'dashboard_login',
  data () {
    return {
      pass: '',
      loading: false,
      wrongMessage: false,
      welcomeHome: false,
    }
  },
  methods: {
    login: function () {

      this.loading = true;
      this.wrongMessage = false;
      this.welcomeHome = false;

      const t1 = /ilence/.test(this.pass);
      const t2 = /brother/.test(this.pass);
      if ( t1 && t2 ) {
        this.loading = false;
        this.welcomeHome = true;
        return;
      }

      this.axios.post('/api/login', {
        password: this.pass,
      })
      .then((response) => {
        this.loading = false;
        if ( response.data.status === 'OK') {
          this.$store.dispatch('login', response.data.userData);
          this.$router.push({ name: 'dashboard' });
        } else {
          this.wrongMessage = true;
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
    },
  },
  created () {
    this.$store.dispatch('changeIndex', {linkName: 'dashboard'});
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text_box {
  margin: 30px 50px;
  padding: 10px;
  background-color: #F5F5F5;
  color: #5E5E5E;
}
.content {
  line-height: 1.5em;
  max-width: 780px;
  margin: 40px auto;
}
.form {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}
.loader_bar {
  background-color: #F5F5F5;
  position: relative;
  margin: 20px 20px 10px 20px;
  height: 60px;
  text-align: center;
}
.fashionFetish {
  font-family: fashionFetish;
}

@media screen and (max-width: 767px) {
  .text_box {
    margin: 30px 10px;
  }
  .content {
    margin: 20px 0;
  }
}

.webflow-style-input input {
  border-style: none;
  background: transparent;
  outline: none;
}

.webflow-style-input button {
  padding: 0;
  background: none;
  border: none;
  outline: none;
}
.webflow-style-input {
  padding: 10px 10px 10px 20px;
  margin: 0 auto;
  position: relative;
  display: flex;
  border-radius: 2px;
  background: rgba(63, 63, 63, 0.8);
}

.webflow-style-input input {
  margin-right: 10px;
  width: 100%;
  flex-grow: 1;
  color: #BFBFBF;
  font-size: 1.8rem;
  line-height: 1.8rem;
  vertical-align: middle;
}
.webflow-style-input input::-webkit-input-placeholder {
  color: #7881A1;
}
.webflow-style-input button {
  color: #878787;
  font-size: 2.4rem;
  line-height: 2.4rem;
  vertical-align: middle;
  transition: color .25s;
}
.webflow-style-input button:hover {
  color: #BFBFBF;
}
.webflow-style-input i {
  font-size: 1.8rem;
  line-height: 2.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/login.vue